var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFitScreen = function SvgFitScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9V6.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H17V4.5h2.692q.758 0 1.283.525t.525 1.283V9zM2.5 9V6.308q0-.758.525-1.283T4.308 4.5H7V6H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212V9zM17 19.5V18h2.692a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V15h1.5v2.692q0 .758-.525 1.283t-1.283.525zm-12.692 0q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V15H4v2.692q0 .116.096.212a.3.3 0 0 0 .212.096H7v1.5zm2.115-3.923V8.423h11.154v7.154zm1.5-1.5h8.154V9.923H7.923z"
  })));
};
export default SvgFitScreen;